module.exports = "/_next/static/images/loading-f2ec2e38b6fa69f690ee569b528bd872.gif";